import React, {useEffect} from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import FitnessLandingPage from './pages/landpage/landpage';
import Footer from './components/Footer/footer';
import ComingSoon from './pages/coming/comingSoon';
import Features from './pages/features/features';
import Contact from './pages/contact/contact';
import FAQ from './components/FAQ/faq';
import TermsAndConditions from './pages/T&C&P/terms';
import PrivacyPolicy from './pages/T&C&P/privacy';
import DownloadPage from './pages/download/download';

function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <ScrollToTopOnRouteChange />
        <Routes>
          <Route path="/" element={<FitnessLandingPage />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/features" element={<Features />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path='/faq' element={<FAQ />} />
          <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/download' element={<DownloadPage />} />
        </Routes>
      </BrowserRouter>
      
    </div>
  );
}

export default App;
